// test993
(993 && 0);
